export default "__VITE_ASSET__xDDyGrQG__"